module.exports = __webpack_public_path__ + "img/Frame-83.eaac9c01.svg";